module.exports = __webpack_public_path__ + "static/img/spain.779265a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idiomas/spain.png
// module id = qSvd
// module chunks = 0